/* eslint-disable ember/no-classic-components */
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';
import { action } from '@ember/object';

@tagName('')
export default class GroupBrowser extends Component {
  // passed in
  selectedGroupType = null;

  groupSearch = '';
  filteredGroups = null;
  selectedGroup = null;
  expandedGroups = null;
  onSelectGroupType = null;
  onSearchChange = null;

  // `{{action ... value="target.value"}}` unwrapped the input value for us;
  // `{{on}}` hands over the event, so unwrap it here before delegating.
  @action
  handleSearchInput(event) {
    if (this.onSearchChange) {
      this.onSearchChange(event.target.value);
    }
  }
  onSelectGroup = null;
  onToggleGroupStudents = null;
  onSelectStudent = null;

  // When true: each row navigates on tap + has an inline chevron to expand students.
  // Used by the hub menu. When false (default): sidebar selected-card behaviour.
  compactMode = false;
}
